import React__default, { useMemo } from 'react';
import { useIntl } from '@grandvisionhq/state';
import { goBack } from '../utils/navigation.js';
import { EmptyCart } from '../components/EmptyCart.js';

const EmptyCartContainer = ({ onClick =goBack  })=>{
    const intl = useIntl();
    const labels = useMemo(()=>({
            cartTitle: intl.getLabel('cart.title'),
            emptyCartTitle: intl.getLabel('cart.emptyCart.title'),
            emptyCartMessage: intl.getLabel('cart.emptyCart.message'),
            buttonCaption: intl.getLabel('cart.actions.goBack')
        })
    , [
        intl.locale
    ]);
    return /*#__PURE__*/ React__default.createElement(EmptyCart, {
        labels: labels,
        onClick: onClick
    });
};

export { EmptyCartContainer };
//# sourceMappingURL=EmptyCartContainer.js.map
